import { Component } from "@angular/core";

@Component({
  selector: "app-splash",
  templateUrl: "./app-splash.component.html",
  styleUrls: ["./app-splash.component.scss"],
})
export class AppSplashComponent {
  constructor() {}
}
